var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplitPackman = function SvgSplitPackman(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.98,
    d: "m9.018 5.403-.065-.09c3.331-2.69 2.961-3.09 2.961-3.09a7 7 0 0 0-1.045-.933A6.2 6.2 0 0 0 9.17.4C6.644-.532 3.64.2 1.832 2.225-.585 4.869-.628 9.07 1.81 11.76c2.57 2.823 6.947 3.001 9.712.4l.044-.044.043-.045.022-.022a.6.6 0 0 0 .109-.133c.784-1.023-.392-3.801-2.722-6.514m2.134 6.002c-.174.177-.914.2-2.112-.445-1.11-.6-2.352-1.623-3.528-2.868A473 473 0 0 1 8.43 5.758c1.024 1.2 1.895 2.512 2.352 3.601.544 1.267.523 1.89.37 2.046"
  })));
};
export default SvgSplitPackman;